module.exports = __webpack_public_path__ + "static/img/app.31a9523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h5/app.png
// module id = hMRd
// module chunks = 163